const flatten = (data, c = '') => {
  const result = {}

  for (const i in data) {
    const isObject = typeof data[i] === 'object' && !Array.isArray(data[i]) && data[i] !== null

    if (isObject) Object.assign(result, flatten(data[i], c + '.' + i))
    else result[(c + '.' + i).replace(/^\./, '')] = data[i]
  }

  return result
}

export default flatten
